import React from "react";
var __jsx = React.createElement;
import stl from "./InputToPopUp.module.css";
var InputToPopUp = function InputToPopUp(_ref) {
  var onInputClick = _ref.onInputClick,
    children = _ref.children,
    className = _ref.className,
    errorMsg = _ref.errorMsg;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.inputContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.textSearchBorder, " ").concat(className ? className : ""),
    onClick: onInputClick
  }, children), errorMsg && /*#__PURE__*/React.createElement("p", {
    className: stl.errorMsg
  }, errorMsg));
};
export default InputToPopUp;